import { Middleware } from '@reduxjs/toolkit';
import {
  actionToUiEventName,
  UiKeyEventName,
} from './dataTransformations';

export interface UiEventLogger {
  readonly event: (eventName: UiKeyEventName) => void;
}

export const loggerToUILoggingMiddleware =
  (logger: UiEventLogger): Middleware =>
    () => (next) => (action) => {
      const result = next(action);

      const eventName = actionToUiEventName(action);
      if (eventName) {
        logger.event(eventName);
      }

      return result;
    };
